// import { useState, useEffect } from 'react';

import { Container, Content } from './styles';
import pd1 from '../../assets/img/pd1.jpg'
import pd2 from '../../assets/img/pd2.jpg'
import pd3 from '../../assets/img/pd3.jpg'
import pd4 from '../../assets/img/pd4.jpg'
import pd5 from '../../assets/img/pd5.jpg'
import pd6 from '../../assets/img/pd6.jpg'
import pd7 from '../../assets/img/pd7.jpg'
import pd8 from '../../assets/img/pd8.jpg'
import pd9 from '../../assets/img/pd9.jpg'
import pd10 from '../../assets/img/pd10.jpg'
import am1 from '../../assets/img/am1.jpg'
import am2 from '../../assets/img/am2.jpg'
import am3 from '../../assets/img/am3.jpg'
import am4 from '../../assets/img/am4.jpg'
import am5 from '../../assets/img/am5.jpg'
import am6 from '../../assets/img/am6.jpg'
import ami1 from '../../assets/img/ami1.jpg'
import ami2 from '../../assets/img/ami2.jpg'
import ami3 from '../../assets/img/ami3.jpg'
import ami4 from '../../assets/img/ami4.jpg'

// import * as Photos from '../../services/photos'

export function Padrinhos() {
    // const [loading, setLoading] = useState(false)
    // const [photos, setPhotos] = useState([])

    // useEffect(() => {
    //     const getPhotosPadrinhos = async () => {
    //         setLoading(true)
    //         setPhotos({name: 'eeeeeee'});
    //         setLoading(false)
    //     }
    //     getPhotosPadrinhos();
    // }, [])

    const padrinhosImg = [
        {
            image: pd1,
            title: 'Weslley e Fabiane',
        },
        {
            image: pd9,
            title: 'Luiz e Jessica',
        },
        {
            image: pd3,
            title: 'Júlison e Amanda',
        },
        {
            image: pd2,
            title: 'Lucas e Cecília',
        }, 
        {
            image: pd5,
            title: 'Junior e Vanessa',
        },       
        {
            image: pd4,
            title: 'Eclisson e Thaysa',
        },
        {
            image: pd6,
            title: 'Ronan e Wanessa',
        },
        {
            image: pd10,
            title: 'Juliana e Thiago',
        },
        {
            image: pd7,
            title: 'Isaac e Ester',
        },
        {
            image: pd8,
            title: 'Raiana e Thiago',
        },
        {
            image: ami1,
            title: 'Fernanda',
        },
        {
            image: ami2,
            title: 'Bruna',
        },
        {
            image: ami3,
            title: 'Miriam',
        },
        {
            image: ami4,
            title: 'Pollyana',
        },
        {
            image: am1,
            title: 'Roberto',
        },
        {
            image: am2,
            title: 'Davi',
        },
        {
            image: am3,
            title: 'Samuel',
        },
        {
            image: am4,
            title: 'Júnior',
        },    
        {
            image: am5,
            title: 'Jefferson',
        },    
        {
            image: am6,
            title: 'Lucas',
        }        
    ];

    return (
        <Container id="padrinhos">
            <h1>Padrinhos</h1>            
            <Content>
                {padrinhosImg.map(image => (
                    <div className="cardList" key={image.title}>
                        <img src={image.image} alt={image.title} />
                        <div className="description">
                            <p>{image.title}</p>
                        </div>
                    </div>
                ))}
            </Content>
        </Container>
    );
}